export class ProjectDeviceLocation {
  public device?: number;
  public parent?: number;
  public name?: string;
  public unit?: number;
  public length?: number;
  public latitude?: number;
  public longitude? : number;
  public device_type?: Object;
}
